var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.iconStyle,attrs:{"tabindex":"0"},on:{"click":_vm.toggleAndSave,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;return _vm.toggleAndSave.apply(null, arguments)}}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.resourceLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }